import { Component, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { ActionCoCardModel, QueovalDate, ActionCoMailModel, BlockItem, BlockTree, QueovalDik, BlockFile, ContactMail, QueovalDateTime, BObjectModel, ActionCoHistory, ActionCoHistoryType, Person } from '../../../models';
import { CoreService, HttpService, UtilitiesService, QueovalDateService } from '../../../services';
import { ToastService } from '../../../toast';
import { b64EncodeUnicode, b64UrlEncodeUnicode } from '../../../utilities';
import { HttpClient } from '@angular/common/http';
import { ActionCoService } from '../action-co-services/action-co.service';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
declare var require: any;
const ClassicEditor: any = require('../../../../../app-queoval/src/assets/ckeditor5/build/ckeditor');
declare var $: JQueryStatic;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-mail',
  templateUrl: './action-co-mail.component.html',
  styleUrls: ['./action-co-mail.component.css']
})

export class ActionCoMailComponent implements OnInit, OnDestroy {
  public boModel: BObjectModel;
  public date: QueovalDate = new QueovalDate();
  public Editor: any = ClassicEditor;
  public contentMail: string = '';
  public contentSms: string = '';
  public Cc: boolean = false;
  public Cci: boolean = false;
  public Sms: boolean = false;

  public forceEdit: boolean = false;
  public ckeditorVersion: string = '4';
  public sender: string = '';
  public smsSender: string = '';
  public lstSmsSenders: Array<string> = new Array<string>();
  public listRecipient: Array<string> = [];
  public listSms: Array<string> = [];
  public listRecipientCc: Array<string> = [];
  public listRecipientBcc: Array<string> = [];
  public Object: string = '';

  public contacts: Array<ContactMail> = [];

  public modeles: Array<QueovalDik> = [];
  public selectedModel: string = '';

  public customerDocuments: Array<BlockFile> = [];
  public devisDocuments: Array<BlockFile> = [];
  public localDocument: Array<BlockFile> = [];

  public files: Array<BlockFile> = [];


  public regexEmail: RegExp = /^\S+@\S+\.\S+$/;
  public regexSms: RegExp = /^(\+)?[0-9()-. ]+$/;

  public localFile: File | null;
  public localFileName: string = '';
  public accept: string = '.pdf, .doc, .docx, .xlsx, .xlsm, .xlsb, .jpg, .jpeg, .png';
  public extension: string = '';

  public localFileIsBeingExported: boolean = false;
  public mailIsSending: boolean = false;

  public attachmentToPdf: boolean = true;

  public subscribeDevisDocument: Subscription;
  @Input() model: ActionCoCardModel;
  @Output() modelChange: EventEmitter<ActionCoCardModel> = new EventEmitter<ActionCoCardModel>();
  @Output() getHistory: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('window:click', ['$event'])
  ClosePopUp(event: any) {
    const popUpcontainer: HTMLElement = (document.getElementById('popUp') as HTMLElement);
    if (!$(event.target).closest(popUpcontainer).length && popUpcontainer) {
      popUpcontainer.classList.remove('d-block');
    }
    const paperclipPopUpcontainer: HTMLElement = (document.getElementById('paperclipPopUp') as HTMLElement);
    if (!$(event.target).closest(paperclipPopUpcontainer).length && paperclipPopUpcontainer) {
      paperclipPopUpcontainer.classList.remove('d-block');
    }
  }

  constructor(
    public indParam: CoreService,
    private http: HttpService,
    public toast: ToastService,
    public httpClient: HttpClient,
    public actionCoService: ActionCoService,
public dateService: QueovalDateService,
  ) { }

  ngOnInit() {
    const clientDB = this.indParam.ClientDB.slice(0, 11);
    const logged = `${this.indParam.AppParams.LoggedUser.NomfaPER} ${this.indParam.AppParams.LoggedUser.Pre01PER}`.slice(0, 11);
    const contactActionCo = `${this.model.ContactPrincipal.Value}`.slice(0, 11);
    const telContactActionCo = `${this.model.ContactPrincipal.PhoneNumber}`.slice(0, 15);
    const mobContactActionCo = `${this.model.ContactPrincipal.MobilePhoneNumber}`.slice(0, 15);
    if (clientDB)
      this.lstSmsSenders.push(clientDB);
    if (contactActionCo)
      this.lstSmsSenders.push(contactActionCo);
    if (telContactActionCo)
      this.lstSmsSenders.push(telContactActionCo);
    if (telContactActionCo)
      this.lstSmsSenders.push(mobContactActionCo);
    if (logged)
      this.lstSmsSenders.push(logged);


    this.boModel = new BObjectModel();
    this.boModel.IdDonneeFils = '0';
    this.boModel.IdDonneePere = '338816';
    this.boModel.IdentBO = '0';
    this.boModel.IdRelation = '286629';
    this.boModel.ShowSaveButton = true;

    if (this.model && this.model.Customer && this.model.Customer.Id && this.model.Customer.Id != '0') {
      this.http.getHttp<ActionCoMailModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Mail/GET_LIST_CONTACTS_BY_CUSTOMER/${this.model.Customer.Id}`).subscribe((result: ActionCoMailModel) => {
        this.contacts = result.Contacts;
        const index: number = this.contacts.findIndex(c => c.Id === this.model.ContactPrincipal.Id);
        if (index > -1) {
          const element: ContactMail = this.contacts[index];
          this.contacts.splice(index, 1);
          this.contacts.splice(0, 0, element);
        }
      });
    }
    this.http.getHttp<ActionCoMailModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Mail/GET_MODELES/0`).subscribe((result: ActionCoMailModel) => {
      this.modeles = result.LstQueovalDik;
    });
    if (this.model && this.model.Customer && this.model.Customer.Id && this.model.Customer.Id != '0') {
      this.http.getHttp<ActionCoMailModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Mail/GET_CUSTOMER_DOCUMENT/${this.model.Customer.Id}`).subscribe((result: ActionCoMailModel) => {
        this.customerDocuments = result.Documents;
      });
    }
    this.subscribeDevisDocument = this.actionCoService.DocumentDevis$.subscribe(() => {
      this.GetDevisDocument();
    });
    this.GetDevisDocument();
  }
  ngOnDestroy() {
    this.subscribeDevisDocument.unsubscribe();
  }

  public OnModelChange(value: string) {
    this.forceEdit = false;
    this.http.getHttp<ActionCoMailModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Mail/PREVIEW_MODEL/${!this.model.ContactPrincipal.Id ? '' : this.model.ContactPrincipal.Id}|${!this.model.Customer.Id ? '' : this.model.Customer.Id}|${!value ? '' : value}/`).subscribe((result: ActionCoMailModel) => {
      this.contentMail = result.Model.ContentMail;
      this.listRecipient = result.Model.To ? result.Model.To : [];
      this.listRecipientCc = result.Model.CC ? result.Model.CC : [];
      this.Cc = this.listRecipientCc.length > 0;
      this.listRecipientBcc = result.Model.CCI ? result.Model.CCI : [];
      this.Cci = this.listRecipientBcc.length > 0;
      this.Object = result.Model.Object;
      this.sender = result.Model.SenderMail.replace(/ /g, '');
      this.ckeditorVersion = result.Model.CkeditorVersion;

    });
  }

  public openPopUp(event: MouseEvent, popUp: string) {
    event.stopPropagation();
    (document.getElementById(popUp) as HTMLElement).classList.toggle('d-block');
    switch (popUp) {
      case 'popUp':
        this.closePopUpPaperclip();
        break;
      case 'paperclipPopUp':
        this.closePopUpScheduledSending();
        break;
    }
  }

  public AccordionClicked(element: HTMLElement) {
    element.classList.toggle("active");
    const panel: any = (element.nextElementSibling as HTMLDivElement);
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = "100000000000000000000000000000000000000000000000000000000000px";
    }
  }

  public ToggleFile(event: any, file: BlockFile): void {
    if (event != null) { event.stopPropagation(); }

    const index: number = this.files.findIndex(f => f.value === file.value && f.key === file.key);
    if (index > -1) {
      file.selected = false;
      this.files.splice(index, 1);
    } else {
      file.selected = true;
      this.files.push(file);
    }
  }

  public ToggleInputButton(element: HTMLElement, action: string): void {
    switch (action) {
      case 'edit':
        $(element).each(function () {
          const parent = this.parentElement;
          (parent as HTMLElement).style.display = 'none';
          ((parent as HTMLElement).nextElementSibling as HTMLElement).style.display = 'flex';
          const inputElement: HTMLInputElement = (((parent as HTMLElement).nextElementSibling as HTMLElement).children[0] as HTMLInputElement);
          inputElement.focus();
          inputElement.selectionStart = inputElement.selectionEnd = 10000;
        });
        break;
      case 'view':
        $(element).each(function () {
          if ($(this).parent().parent().parent().hasClass('wrong-email')) {
            $(this).parent().parent().parent().removeClass('wrong-email');
          }
          const regexMail: RegExp = /^\S+@\S+\.\S+$/;
          if (regexMail.test((this as HTMLInputElement).value)) {
            const parent = this.parentElement;
            (parent as HTMLElement).style.display = 'none';
            ((parent as HTMLElement).previousElementSibling as HTMLElement).style.display = 'flex';
          } else {
            $(this).focus();
            (this as HTMLInputElement).selectionStart = (this as HTMLInputElement).selectionEnd = 10000;
            $(this).parent().parent().parent().addClass('wrong-email');
          }
        });
        break;
    }
  }

  public RemoveItemFromList(index: number, list: Array<any>): void {
    list.splice(index, 1);
  }
  public AddItemToList(event: any, list: Array<string>): void {
    if ($(event.target).parent().hasClass('wrong-email')) {
      $(event.target).parent().removeClass('wrong-email');
    }
    if (event.key === ' ' || event.key === 'Tab' || event.key === 'Enter') {
      const regexMail: RegExp = /^\S+@\S+\.\S+$/;
      event.target.value = (event.target.value as any).replaceAll(' ', '');
      if (regexMail.test(event.target.value)) {
        list.push(event.target.value);
      } else {
        $(event.target).parent().addClass('wrong-email');
      }
    }
  }

  public trackByFn(index: number, item: any) {
    return index;
  }

  public SendMail(isProgramed: boolean): void {
    if (isProgramed) {
      if (this.dateService.IsNull(this.date)) {
        this.toast.showInfoToast('Veuillez renseigner une date valide.');
        return;
      }
      const invalidDate: boolean = this.dateService.Compare(this.date, '<=', this.dateService.Now())
      if (invalidDate) {
        this.toast.showInfoToast('Veuillez renseigner une date supérieure à la date du jour.');
        return;
      }
    }
    if ((!this.sender && !this.Sms) || (!this.smsSender && this.Sms)) {
      this.toast.showInfoToast(`veuillez renseigner l'expéditeur.`);
      return;
    }

    if (((!this.listRecipient || this.listRecipient.length < 1) && (!this.Cc || !this.listRecipientCc || this.listRecipientCc.length < 1) && (!this.Cci || !this.listRecipientBcc || this.listRecipientBcc.length < 1) && !this.Sms) || (this.Sms && (!this.listSms || this.listSms.length < 1))) {
      this.toast.showInfoToast(`veuillez renseigner au moins un destinataire.`);
      return;
    }
    const model: ActionCoMailModel = new ActionCoMailModel();
    this.mailIsSending = true;
    model.attachmentToPdf = this.attachmentToPdf;
    if (this.Sms) {
      model.Mode = 'SEND_SMS';
      const smss: Array<string> = [];
      this.listSms.forEach((sms: string) => {
        if (!sms.startsWith('+')) {
          smss.push(`+33${sms.slice(1)}`.replace(/ /g, '').replace(/\./g, '').replace(/-/g, '').replace(/\(/g, '').replace(/\)/g, ''));
        } else {
          smss.push(sms.replace(/ /g, '').replace(/\./g, '').replace(/-/g, '').replace(/\(/g, '').replace(/\)/g, ''));
        }
      });
      model.Model.To = smss;
      model.Model.ContentMail = this.contentSms;
      var letterNumber = /^[0-9a-zA-Z]+$/;
      var Number = /^[0-9]+$/;
      if ((!Number.test(this.smsSender) && letterNumber.test(this.smsSender) && this.smsSender.length > 11) || (Number.test(this.smsSender) && this.smsSender.length > 15)) {
        this.mailIsSending = false;
        this.toast.showInfoToast(`l'expéditeur est limité à 11 caractères alphanumériques ou 15 numériques.`);
        return;
      }

      model.Model.SenderMail = this.smsSender;
    } else {
      model.Mode = 'SEND_MAIL';
      model.Model.SenderMail = this.sender;
      model.Model.ContentMail = this.contentMail;
      model.Model.To = this.listRecipient;
      model.Model.CC = this.Cc ? this.listRecipientCc : [];
      model.Model.CCI = this.Cci ? this.listRecipientBcc : [];
      model.Model.Object = this.Object;
      if (this.files && this.files.length > 0) {
        model.Attachments = {};
        this.files.forEach((file: { key: string, value: string, selected: boolean }) => {
          model.Attachments[file.value] = file.key;
        });
      }
    }
    if (isProgramed) {
      model.Programed = this.date;
    }

    this.http.postHttp<ActionCoMailModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Mail/`, model).subscribe((result: ActionCoMailModel) => {
      this.mailIsSending = false;
      if (!result.HasSomeError) {
        const history: ActionCoHistory = new ActionCoHistory();
        history.Type = ActionCoHistoryType.sendMail;
        history.Values = [this.Object, this.files.map(entry => {
          let fileName: string = entry.fileName;
          if (!this.attachmentToPdf || (this.attachmentToPdf && entry.extension !== '.doc' && entry.extension !== '.docx')) {
            fileName += entry.extension;
          } else if (this.attachmentToPdf && (entry.extension === '.doc' || entry.extension === '.docx')) {
            fileName += '.pdf';
          }
          return fileName;
        }).join(', ')];

        let dateNow: Date = new Date();
        const annee: string = dateNow.getFullYear().toString();
        const mois: string = (dateNow.getMonth() + 1).toString();
        const jour: string = dateNow.getDate().toString();
        const heures: number = dateNow.getHours();
        const minutes: number = dateNow.getMinutes();
        const sec: number = dateNow.getSeconds();
        history.Date = new QueovalDateTime(annee, mois, jour, heures.toString(), minutes.toString(), sec.toString());
        this.SaveHistory(history);
      }
    });
  }

  public CopyToClipBoard(value: string): void {
    var input = document.createElement('textarea');
    input.innerHTML = value;
    input.value = value;
    document.body.appendChild(input);
    input.select();
    input.focus();
    input.setSelectionRange(0, 99999); /* For mobile devices */
    var result = document.execCommand('copy');
    navigator.clipboard.writeText(input.value);
    document.body.removeChild(input);
    this.toast.showInfoToast('lien copié dans le presse-papiers')
  }

  public onSelectLocalFileChange(e: any): void {
    this.localFile = null;
    const file: File = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    const SplitFile: Array<string> = file.name.split('.');
    const extension: string = SplitFile[SplitFile.length - 1].toLowerCase();
    const extensionAccepted: Array<string> = this.accept.toLowerCase().replace(/\.| /g, '').split(',');
    if (extensionAccepted.includes(extension)) {
      this.extension = extension;
      this.localFile = file;
      this.localFileName = file.name;
    } else {
      this.toast.showAlertToast(`${this.indParam.getTrad('InvalidFormat')} ${this.accept})`);
    }
  }

  public OnFileSave(e: any): void {
    e.stopPropagation();
    if (this.localFile === null) {
      this.toast.showInfoToast("aucun fichier reconnu n'est sélectionné.");
      return;
    }
    this.localFileIsBeingExported = true;
    const blob: Blob = this.localFile.slice(0, this.localFile.size, this.localFile.type);
    const origin: string = this.localFile.name;    
    this.localFile = new File([blob], this.localFileName, { type: this.localFile.type });
    if (this.localFile === undefined || this.localFile === null) {
      this.toast.showInfoToast("aucun fichier reconnu n'est sélectionné.");
      return;
    }

    const model: ActionCoMailModel = new ActionCoMailModel();
    model.Mode = 'CREATE_CUSTOMER_BO_DOCUMENT';
    model.NewDocument = new BlockFile();
    model.NewDocument.fileName = origin;
    model.NewDocument.value = this.model.Customer.Id;
    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/ActionCo/Mail/`,model).subscribe((result: ActionCoMailModel) => {
      this.localFileName = this.localFileName.endsWith(this.extension) ? this.localFileName : `${this.localFileName}.${this.extension}`;

      const localFileName: string = b64EncodeUnicode(this.localFileName);
      const originFileName: string = b64EncodeUnicode(origin);
      const fileName: string = b64EncodeUnicode((this.localFile as File).name);

      const ConfigFile: any = {
        responseType: 'arraybuffer' as 'arraybuffer',
        headers: { 'Queoval': this.indParam.AppParams.token, 'mode': 'INSERTDOC', 'fileName': originFileName, 'IdDonnee': result.LstQueovalDik[0].value, 'IdRelation': result.LstQueovalDik[0].key }
      };

      const formData: FormData = new FormData();
      formData.append('file', (this.localFile as File), fileName);
      formData.append('name', localFileName);
      formData.append('IDDONNEE', result.LstQueovalDik[0].value);
      formData.append('IDRELATION', result.LstQueovalDik[0].key);
      formData.append('ISCHILD', 'TRUE');
      formData.append('mode', 'INSERTDOC');
      formData.append('token', this.indParam.AppParams.token);

      this.httpClient.post(`${this.indParam.AppParams.apiUrl}api/Upload`, formData, ConfigFile).subscribe((data: any) => {
        const file = new BlockFile();
        file.key = (this.localFile as File).name;
        file.value = result.LstQueovalDik[0].value;
        file.selected = true;
        file.isWebLink = false;                        
        const SplitFile: Array<string> = (this.localFile as File).name.split('.');
        file.extension = `.${SplitFile[SplitFile.length - 1].toLowerCase()}`;
        file.fileName = (this.localFile as File).name.substring(0, (this.localFile as File).name.length - file.extension.length - 1);

        this.files.push(file);
        this.localDocument.push(file);
        this.customerDocuments.push(file);
        this.localFile = null;
        this.localFileName = '';
        this.localFileIsBeingExported = false;
      },
        (error: any) => {
          this.http.getHttp<ActionCoMailModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Mail/DELETE_CUSTOMER_BO_DOCUMENT/${this.model.Customer.Id}|${result.LstQueovalDik[0].value}|${result.LstQueovalDik[0].key}`).subscribe();
          console.error(JSON.stringify(error));
          this.toast.showAlertToast('Une erreur est survenue lors de la création du fichier.');
          this.localFile = null;
          this.localFileName = '';
          this.localFileIsBeingExported = false;
        });

    });

  }
  private async SaveHistory(history: ActionCoHistory): Promise<boolean> {
    const model: ActionCoCardModel = new ActionCoCardModel();
    model.Mode = 'SET_HISTORY_BY_ID_ACTION_CO';
    model.idActionCo = this.model.idActionCo;
    model.Customer.Id = this.model.Customer.Id;
    model.Customer.SocialReason = this.model.Customer.SocialReason;
    model.ContactPrincipal = new Person();
    model.History = [history];
    return await this.http.postHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/`, model).toPromise().then(
      (data: ActionCoCardModel) => {
        if (data.HasAlert) return false;
        this.getHistory.emit();
        return true;
      });
  }

  private closePopUpScheduledSending(): void {
    (document.getElementById('popUp') as HTMLElement).classList.remove('d-block')
  }
  private closePopUpPaperclip(): void {
    (document.getElementById('paperclipPopUp') as HTMLElement).classList.remove('d-block')
  }
  private GetDevisDocument(): void {
    if (this.model && this.model.idActionCo && this.model.idActionCo != '0') {
      this.http.getHttp<ActionCoMailModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Mail/GET_DEVIS_DOCUMENT/${this.model.idActionCo}`).subscribe((result: ActionCoMailModel) => {
        this.devisDocuments = result.Documents;
      });
    }
  }
}
